import React from "react"
import { LoadableP5 } from "./loadable";
import EpochSketch from "./epoch-sketch";

function P5Component(seed) {
    if (typeof window !== "undefined") {
    return <LoadableP5 sketch={EpochSketch} seed={seed} />
    }
    else {
        return null;
    }
}

export default P5Component;